import { Outlet } from 'react-router'

import { BottomNav } from '@/shared/ui'

/**
 * Layout for the 33 screens that carry the bottom navigation.
 *
 * The shell owns two things its screens must not repeat. It is the page
 * column, so the backdrop, its glows and the nav bar all line up with the
 * content instead of the window. And the outlet wrapper is a flex column that
 * grows, which is what lets a screen fill the shell — `min-h-full` cannot,
 * because a percentage minimum has no definite parent height to resolve
 * against and collapses on a short page.
 */
export function AppShell() {
  return (
    <div className="sx-page sx-backdrop-app flex min-h-dvh flex-col">
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  )
}
